import Vue from 'vue'
import store from '@/store'
import i18n from '../i18n'

Vue.filter('truncate', (sentence, length) => sentence.slice(0, length) + (length < sentence.length ? '...' : ''))

Vue.filter('formatDate', date => {
  if (!date) return ''

  let locale

  switch(store.state.userSettings.locale) {
    case 'en':
      locale = 'en-GB'
      break
    case 'nn':
      locale = 'nn-NO'
      break
    default:
      locale = 'nb-NO'
  }

  const dateTransform = new Date(date).toLocaleString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })

  const time = new Date(date).toLocaleString(locale, {
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short'
  })

  return `${dateTransform} ${i18n.t('AT')} ${time}`
})
